// extracted by mini-css-extract-plugin
export const intro = "about-intro-module--intro--wL_iw";
export const contentContainer = "about-intro-module--content-container--3ZOba";
export const image = "about-intro-module--image--1PPBW";